import React from "react";
import { Container, Row, Col } from "react-bootstrap/esm/index";

export default function Section({
  children,
  sectionClass = "",
  sectionId = "",
}) {
  return (
    <React.Fragment>
      <section className={sectionClass} id={sectionId}>
        <Container>
          <Row>
            <Col>{children}</Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
}
